// extracted by mini-css-extract-plugin
module.exports = {"edit-pricing-button":"EditPriceButton_edit-pricing-button__3g9RS","inactive":"EditPriceButton_inactive__Kt2rK"};